<template>
  <div class="menu-bar">
    <div class="menu-bar-item">
        <div class="center-row">
           <a-tooltip placement="right">
        <template slot="title">
          <span>我的书签</span>
        </template>
          <router-link to="/">
        <img src="../../assets/img/bookmarkIcon.png" class="menu-bar-item-img"/>
          </router-link>
           </a-tooltip>
        </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.menu-bar {
  width: 80px;
  background: #19a0fb;
  height: auto;
  min-height: 100vh;
  padding-top: 80px;
}
.menu-bar-item {
  width: 70px;
  height: 80px;
  background: #19a0fb;
  margin-left: 10px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.menu-bar-item:hover {
  background: #ffffff;
}
.menu-bar-item-img{
    width: 25px;
    height: 25px;
    background: #ffffff;
    border-radius: 6px;
}
.center-row{
    margin: auto;
}
</style>